(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  const firstSectionImage = document.querySelector('.main-content > .shopify-section img');
  if (firstSectionImage) {
    firstSectionImage.setAttribute('loading', 'eager');
    firstSectionImage.setAttribute('fetchpriority', 'high');
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-kop-menu"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.hsKopMenuKlaar) return;
  window.hsKopMenuKlaar = true;
  var desktop = window.matchMedia('(min-width: 990px)');
  var isTouch = window.matchMedia('(hover: none)').matches;
  var menu = null;          // de actieve nav; de thema-editor vervangt hem bij elke wijziging
  var openTimer = null, sluitTimer = null;

  // plakken: de kopgroep krijgt een negatieve top ter grootte van de balken boven dit menu, zodat bij
  // scrollen alleen deze menurij blijft hangen. Broadcast meet zijn eigen (op desktop verborgen) kop en
  // zet --header-height op 0; hier krijgt die variabele de hoogte van dit menu, zodat de plakkende
  // filterbalk van collecties, het koopblok van de productpagina en ankerlinks onder het menu blijven.
  function meet() {
    if (!menu) return;
    var groep = menu.closest('.header-sections');
    if (!desktop.matches) {
      if (groep) groep.style.removeProperty('--hs-menu-top');
      menu.removeAttribute('data-header-height');
      return;
    }
    if (groep) {
      var afstand = menu.getBoundingClientRect().top - groep.getBoundingClientRect().top;
      groep.style.setProperty('--hs-menu-top', (-Math.round(afstand)) + 'px');
    }
    menu.setAttribute('data-header-height', '');
    document.documentElement.style.setProperty('--header-height', menu.offsetHeight + 'px');
  }
  var bezig = false;
  function kijk() {
    if (bezig || !menu) return;
    bezig = true;
    window.requestAnimationFrame(function () {
      bezig = false;
      if (!menu) return;
      var stuck = desktop.matches && window.scrollY > 0 && menu.getBoundingClientRect().top <= 0.5;
      menu.classList.toggle('is-stuck', stuck);
    });
  }
  function meetEnKijk() { meet(); kijk(); }

  // panelen
  function link(li) { return li.querySelector('[data-hs-menu-link]'); }
  function open(li) {
    li.classList.add('is-open');
    var a = link(li); if (a) a.setAttribute('aria-expanded', 'true');
  }
  function sluit(li) {
    li.classList.remove('is-open');
    var a = link(li); if (a) a.setAttribute('aria-expanded', 'false');
  }
  function sluitAlles(behalve) {
    if (!menu) return;
    menu.querySelectorAll('[data-hs-menu-item].is-open').forEach(function (li) { if (li !== behalve) sluit(li); });
  }

  // beelden in de panelen alvast laden zodra de bezoeker het menu op desktop bereikt (ze staan op lazy)
  function laadBeelden() {
    if (!menu || !desktop.matches || menu.dataset.hsBeelden) return;
    menu.dataset.hsBeelden = '1';
    menu.querySelectorAll('.hs-kop-menu__paneel img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
  }

  function init(nav) {
    menu = nav;
    meetEnKijk();
    nav.addEventListener('pointerenter', laadBeelden);
    nav.addEventListener('focusin', laadBeelden);

    // zoeken vanuit de plakkende balk: naar boven en het zoekveld activeren
    var zoekKnop = nav.querySelector('[data-hs-menu-zoek]');
    if (zoekKnop) {
      zoekKnop.addEventListener('click', function () {
        var veld = document.querySelector('.hs-kop-zoek input[name="q"]');
        window.scrollTo({ top: 0, behavior: 'smooth' });
        if (!veld) return;
        var pogingen = 0;
        var probeer = function () {
          pogingen += 1;
          if (window.scrollY > 2 && pogingen < 12) { setTimeout(probeer, 100); return; }
          veld.focus({ preventScroll: true });
        };
        setTimeout(probeer, 150);
      });
    }

    nav.querySelectorAll('[data-hs-menu-item]').forEach(function (li) {
      var a = link(li);
      // muis: openen met een kleine vertraging (tegen per ongeluk openen als de muis langs de rij
      // beweegt), sluiten kort na verlaten
      li.addEventListener('mouseenter', function () {
        if (isTouch || !desktop.matches) return;
        clearTimeout(sluitTimer); clearTimeout(openTimer);
        openTimer = setTimeout(function () { sluitAlles(li); open(li); }, 120);
      });
      li.addEventListener('mouseleave', function () {
        if (isTouch || !desktop.matches) return;
        clearTimeout(openTimer);
        sluitTimer = setTimeout(function () { sluit(li); }, 80);
      });
      // toetsenbord: Tab op de link opent het paneel, verlaten van het item sluit het
      li.addEventListener('focusin', function () {
        if (!desktop.matches) return;
        sluitAlles(li); open(li);
      });
      li.addEventListener('focusout', function (event) {
        if (!desktop.matches) return;
        if (event.relatedTarget && li.contains(event.relatedTarget)) return;
        sluit(li);
      });
      if (a) {
        // pijl omlaag: naar de eerste link in het paneel
        a.addEventListener('keydown', function (event) {
          if (event.key !== 'ArrowDown' || !desktop.matches) return;
          event.preventDefault();
          open(li);
          var eerste = li.querySelector('.hs-kop-menu__paneel a:not([tabindex="-1"])');
          if (eerste) eerste.focus();
        });
        // aanraakscherm op desktopbreedte: eerste tik opent het paneel, tweede tik volgt de link
        a.addEventListener('click', function (event) {
          if (!isTouch || !desktop.matches) return;
          if (!li.classList.contains('is-open')) {
            event.preventDefault();
            sluitAlles(li);
            open(li);
          }
        });
      }
    });
  }

  // luisteraars op document en window: eenmalig
  window.addEventListener('scroll', kijk, { passive: true });
  window.addEventListener('resize', meetEnKijk);
  window.addEventListener('load', meetEnKijk);
  document.addEventListener('theme:resize', meetEnKijk);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(meetEnKijk);
  document.addEventListener('theme:cart:change', function (event) {
    if (!menu) return;
    var d = event.detail || {};
    var n = (typeof d.cartCount === 'number') ? d.cartCount : (d.cart && typeof d.cart.item_count === 'number' ? d.cart.item_count : null);
    if (n === null) return;
    menu.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('hs-kop-menu__teller--nul', n === 0);
    });
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || !menu) return;
    // eerst de focus terug op de link van het open item (dat opent het paneel via focusin), dan alles sluiten
    var openItem = menu.querySelector('[data-hs-menu-item].is-open');
    if (openItem && openItem.contains(document.activeElement)) { var a = link(openItem); if (a) a.focus(); }
    sluitAlles(null);
  });
  document.addEventListener('click', function (event) { if (menu && !menu.contains(event.target)) sluitAlles(null); });
  // thema-editor: de sectie wordt vervangen bij elke wijziging; dan opnieuw koppelen
  document.addEventListener('shopify:section:load', function (event) {
    var nav = event.target && event.target.querySelector ? event.target.querySelector('[data-hs-menu]') : null;
    if (nav) init(nav); else setTimeout(meetEnKijk, 50);
  });
  document.addEventListener('shopify:section:unload', function () { setTimeout(meetEnKijk, 50); });

  var eerste = document.querySelector('[data-hs-menu]');
  if (eerste) init(eerste);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-kop-zoek"] && !Shopify.designMode) return;
  try {
    
// B-2: Broadcast werkt alleen de teller in zijn eigen kopsectie bij; deze luisteraar doet dat voor de onze.
document.addEventListener('theme:cart:change', function (event) {
  var d = event.detail || {};
  var n = (typeof d.cartCount === 'number') ? d.cartCount : (d.cart && typeof d.cart.item_count === 'number' ? d.cart.item_count : null);
  if (n === null) return;
  document.querySelectorAll('.hs-kop-zoek [data-cart-count]').forEach(function (el) {
    el.textContent = n;
    el.classList.toggle('hs-kop-zoek__teller--nul', n === 0);
  });
});
document.addEventListener('click', function (event) {
  var link = event.target.closest('[data-hs-cart-lade="true"]');
  if (!link) return;
  if (window.theme && window.theme.settings && window.theme.settings.cartDrawerEnabled) {
    event.preventDefault();
    document.dispatchEvent(new CustomEvent('theme:cart:toggle', { bubbles: true }));
  }
});

  } catch(e) { console.error(e); }
})();
})();
